export default __webpack_public_path__ + "static/media/zampanino.e00ae7ab.txt";